import * as msg from "../../message";

const state = {
  error: "",
  message: {
    text: "",
    btnText: "",
    type: ""
  },
  showAlert: {
    type: "",
    message: ""
  },
  messageBox: {
    btnText: "",
    text: "",
    type: "",
    info: "",
    open: true
  }
};

const mutations = {
  errorMessage(state, data, rootState) {
    // rootState.system.loading = false;
    state.error = data;
  },
  clearMessage(state) {
    state.message.text = "";
    state.message.btnText = "";
    state.message.type = "";
  },
  showAlert(state, data) {
    state.showAlert.type = data.type;
    state.showAlert.message = data.message;
  },
  resetAlert(state) {
    state.showAlert.type = "";
    state.showAlert.message = "";
  },
  showMessage(state, data) {
    state.message.text = data.msg;
    state.message.btnText = data.btntext;
    state.message.type = data.type;
  },
  clearErrMessage(state) {
    state.error = "";
  },
  clearMessageBox(state) {
    state.messageBox.text = "";
    state.messageBox.btnText = "";
    state.messageBox.type = "";
    state.messageBox.info = "";
    state.messageBox.open = false;
  },
};

const actions = {
  displayMessage({
    commit
  }, data) {
    let error = {
      msg: msg.LOGIN_REDIRECT,
      btntext: "Login",
      type: "logout"
    };
    if (data.response.data.status == "redirect_to_store_list") {
      commit("showMessage", error);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};